import { create } from '../../utils/create';
import { CartInHeader } from './CartInHeader';
import { SearchInHeader } from './SearchInHeader';
export class Header {
    constructor(parent, go, controller) {
        this.update = () => {
            this.render();
        };
        this.render = () => {
            var _a, _b;
            (_a = this.component) === null || _a === void 0 ? void 0 : _a.remove();
            this.cartInHeader.render();
            this.searchInHeader.render();
            (_b = this.searchInHeader.searchInput) === null || _b === void 0 ? void 0 : _b.addEventListener('input', () => {
                var _a, _b, _c;
                (_a = this.searchWrapper) === null || _a === void 0 ? void 0 : _a.classList.add('search_oninput');
                if (((_b = this.searchInHeader.searchInput) === null || _b === void 0 ? void 0 : _b.value) === '') {
                    (_c = this.searchWrapper) === null || _c === void 0 ? void 0 : _c.classList.remove('search_oninput');
                }
            });
            const linkToMain = create({
                tagName: 'a',
                dataAttr: [['href', '/']],
                children: [
                    create({
                        tagName: 'h1',
                        classNames: 'header__logo',
                        children: [
                            create({
                                tagName: 'img',
                                classNames: 'header__logo-img',
                                dataAttr: [
                                    ['src', '/assets/img/AnimeOz-removebg-preview.png'],
                                    ['alt', 'logo']
                                ]
                            })
                        ]
                    })
                ]
            });
            linkToMain.addEventListener('click', this.go);
            this.cardWrapper = create({
                tagName: 'div',
                classNames: 'cart-shopping__wrapper',
                children: [this.cartInHeader.cart, this.cartInHeader.goodsCounterBlock]
            });
            this.searchWrapper = create({
                tagName: 'div',
                classNames: 'search',
                children: [this.searchInHeader.searchInput, this.searchInHeader.searchButton]
            });
            this.component = create({
                tagName: 'div',
                classNames: 'header__wrapper',
                children: [linkToMain, this.searchWrapper, this.cardWrapper],
                parent: this.parent
            });
        };
        this.renderCartWrapper = () => {
            var _a, _b;
            this.cartInHeader.render();
            if (this.cardWrapper !== null) {
                (_a = this.component) === null || _a === void 0 ? void 0 : _a.removeChild(this.cardWrapper);
                this.cardWrapper = create({
                    tagName: 'div',
                    classNames: 'cart-shopping__wrapper',
                    children: [
                        this.cartInHeader.cart,
                        this.cartInHeader.goodsCounterBlock,
                        this.cartInHeader.goodsTotalSumBlock
                    ]
                });
                (_b = this.component) === null || _b === void 0 ? void 0 : _b.appendChild(this.cardWrapper);
            }
        };
        this.renderSearchWrapper = () => {
            var _a, _b;
            this.searchInHeader.render();
            if (this.searchWrapper !== null) {
                (_a = this.component) === null || _a === void 0 ? void 0 : _a.removeChild(this.searchWrapper);
                this.searchWrapper = create({
                    tagName: 'div',
                    classNames: 'search',
                    children: [this.searchInHeader.searchInput, this.searchInHeader.searchButton]
                });
                (_b = this.component) === null || _b === void 0 ? void 0 : _b.appendChild(this.searchWrapper);
            }
        };
        this.parent = parent;
        this.component = null;
        this.go = go;
        this.controller = controller;
        this.goodsCounter = 0;
        this.cartInHeader = new CartInHeader(controller, go);
        this.cardWrapper = null;
        this.searchInHeader = new SearchInHeader(controller);
        this.searchWrapper = null;
    }
}
